import { DatastoreInterface } from '@freelancer/datastore/core';
import { UserCalifornianStatus } from './user-californian-statuses.model';
import { UserCalifornianStatusesCollection } from './user-californian-statuses.types';

interface GenerateUserCalifornianStatusesOptions {
  readonly userId: number;
}

export async function createUserCalifornianStatuses(
  datastore: DatastoreInterface,
  options: GenerateUserCalifornianStatusesOptions,
) {
  const object = generateUserCalifornianStatusesObject(options);
  await datastore.createDocument<UserCalifornianStatusesCollection>(
    'userCalifornianStatuses',
    object,
  );
  return object;
}

// TODO: Make this toggleable when we begin testing Cali
function generateUserCalifornianStatusesObject({
  userId,
}: GenerateUserCalifornianStatusesOptions): UserCalifornianStatus {
  return {
    id: userId.toString(),
    ip: '204.236.225.72',
    isUserPotentiallyCalifornian: false,
    isUserCalifornian: false,
  };
}
